'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Toast = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _toastcomponent = require('./toastcomponent.js');

var _toastcomponent2 = _interopRequireDefault(_toastcomponent);

var _toast = require('./toast.css');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _instance = void 0;

var Toast = exports.Toast = function () {
    if (!_instance) {
        var div = document.createElement('div');
        document.body.appendChild(div);
        _instance = _reactDom2.default.render(_react2.default.createElement(_toastcomponent2.default, null), div);
    }
    return _instance;
}();